import api from './apiClient';

const reviewApi = {
  getReviews: (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      const value = filters[key];
      // Include search even if it's an empty string (but not null/undefined)
      if (key === 'search') {
        if (value !== null && value !== undefined && value !== 'all') {
          params.append(key, value);
        }
      } else if (value && value !== 'all') {
        params.append(key, value);
      }
    });
    const queryString = params.toString();
    return api.get(`/performance/reviews${queryString ? `?${queryString}` : ''}`);
  },
  getReviewById: (id) => api.get(`/performance/reviews/${id}`),
  createReview: (data) => api.post('/performance/reviews', data),
  updateReview: (id, data) => api.put(`/performance/reviews/${id}`, data),
  deleteReview: (id) => api.delete(`/performance/reviews/${id}`),
  submitReview: (id, data) => api.patch(`/performance/reviews/${id}/submit`, data),
  approveReview: (id, reason) => api.patch(`/performance/reviews/${id}/approve`, { reason }),
  rejectReview: (id, reason) => api.patch(`/performance/reviews/${id}/reject`, { reason }),
  getReviewsByEmployee: (employeeId) => api.get(`/performance/reviews/employee/${employeeId}`),
  getReviewsByManager: (managerId) => api.get(`/performance/reviews/manager/${managerId}`),
  getReviewsByCycle: (cycleId) => api.get(`/performance/reviews/cycle/${cycleId}`),
  getSelfReview: (employeeId, cycleId) => api.get(`/performance/reviews/self/${employeeId}/${cycleId}`),
  getManagerReview: (employeeId, cycleId) => api.get(`/performance/reviews/manager/${employeeId}/${cycleId}`),
  getReviewKPIs: (reviewType = "self") => api.get(`/performance/reviews/kpi?reviewType=${reviewType}`)
};

export { reviewApi };
